<template>
    <div class="titlebox">
      <div class="titlebar"></div>{{title}} <div class="titleline"></div>
    </div>
</template>

<script>
    export default {
        name: "SplitTitle",
      props:{
          title:{
            type:String,
            default:'标题'
          }
      }
    }
</script>

<style scoped>
.titlebox{
  color:#20384D;
  font-size: 16px;
  display: flex;
  align-items: center;
  margin-bottom: 30px;

}
  .titlebar{
    width: 4px;
    height: 16px;
    background: #035EBA;
    margin-right: 10px;
  }
  .titleline{
    flex: 1;
    height: 2px;
    background: #E6E9EE;
    margin-left: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/SplitTitle.vue